import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Badge from '@components/ringil3/Badges/Badge';
import { isNotNullOrUndefined } from '@utils/utils';
import { formatDateTimeInTzWithLocale } from '@utils/dateWithTz';

interface ComponentProps {
  createdAt: string;
  createdBy: string;
  timezoneId: string;
  dataTestId?: string;
}

const CreatedBadge: React.FC<ComponentProps> = ({ createdAt, createdBy, timezoneId, dataTestId }) => {
  const { tr } = useTranslationLgs();
  return (
    <>
      {isNotNullOrUndefined(createdAt) && (
        <Badge filled={false} value={`${createdBy}, ${formatDateTimeInTzWithLocale(createdAt, timezoneId)}`} label={tr(`CreatedBadge.title`, `Created`)} highlightedValue={false} dataTestId={dataTestId}></Badge>
      )}
    </>
  );
};

export default CreatedBadge;
